import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import FeedCard from './FeedCard/FeedCard';

const FeedPageVirtualized = ({items = [], parentWidth, handleOpenMediaViewer = () =>{}})=>{
    const [height, setHeight] = useState(0);

    const [ref, inView, entry] = useInView({
        triggerOnce: false,
        initialInView:true,
        threshold: 0,
        rootMargin: '100% 0px'
    });

    useEffect(() => {
        if (entry) {
            const newHeight = entry.boundingClientRect.height;
            if (newHeight !== height && newHeight > 1) {
                setHeight(newHeight);
            }
        }
    }, [entry, height]);

    const renderItems = (items)=>{
        return items.map((item) => item._id ? <FeedCard publication={item} key={item._id} parentWidth={parentWidth} handleOpenMediaViewer={handleOpenMediaViewer}/> : null)
    }

    return (
        <div ref={ref}>
            {inView ? renderItems(items) : <div style={{height:`${height}px`}}/>}
        </div>
    )
}

export default React.memo(FeedPageVirtualized);